import React, { FC } from "react";
import "./style.scss";

type ConsentErrorProps = {
  isEnabled: boolean;
  errorText?: string;
};

// TODO:Error時の表示切替の値を受け取れるように
export const ConsentError: FC<ConsentErrorProps> = (props) => {
  const { isEnabled, errorText } = props;
  if (isEnabled) {
    return <span className="consentError">{errorText}</span>;
  }
  return null;
};
